import React from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { getCaseStyle, formatNull, formatDate } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';
import WarningPanel from '../WarningPanel';
import ViewFileById from '../ViewFileById';

import Modal from '../Modal';
import EditInsurance from './Components/EditInsurance';

import ButtonWithConfirmation from '../ButtonWithConfirmation';

import IconContainer from '../IconContainer';
import { ReactComponent as PenIcon } from '../../icons/pen.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const Insurance = ({ userId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openTimeModal } = useTimeModal();

  const [cases, setCases] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-user-insurance?id=${userId}`)
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload, userId]);

  const deleteEntry = (id) => {
    const token = localStorage.getItem('token');

    axios.delete('/api/delete-insurance', {
      data: { id },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      openTimeModal('Запись удалена', 'success');
      setReload(true);
    })
    .catch((error) => {
      openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const [isEditModal, setIsEditModal] = React.useState(false);

  const [currentId, setCurrentId] = React.useState('');
  const [currentAction, setCurrentAction] = React.useState('');

  const openSuperModal = (id, action) => {
    setCurrentId(id);
    setCurrentAction(action);
    setIsEditModal(true);
  };

  return (
    <>
      <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)}>
          <EditInsurance id={currentId} action={currentAction} userId={userId} onSuccess={() => setReload(true)} />
      </Modal>

      <div className='panel linksPanel'>
        <h3>ООО «СБ Арбитр»</h3>
        <p>Уполномоченное лицо ООО «СБ Арбитр» по взаимодействию Союза по вопросам страхования:</p>
        <p>Савченко Елена Николаевна</p>
        <span className='horizontalContainer' style={{justifyContent: 'start'}}><p>Телефон: </p><a className='aWithLink' href='tel:89031150054'>+7 903 115 0054</a></span>
        <span className='horizontalContainer' style={{justifyContent: 'start'}}><p>Email: </p><a className='aWithLink' href='mailto:sbarbitr.ins@yandex.ru'>sbarbitr.ins@yandex.ru</a></span>
      </div>

      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
              <button type='button' className='secondaryButton' onClick={() => {openSuperModal('', 'add')}}>
                <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                  <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                </svg>
                Добавить договор обязательного страхования ответственности
              </button>
              <a className='lastUpdateWrapper'>
                  {loading ? 
                      <Loading type='inline' /> 
                  : 
                      <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                  }
              </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '25fr 14fr 12fr 12fr 12fr 12fr 7fr 6fr' }}>
              <div>Наименование страховой компании</div>
              <div>Номер и дата договора</div>
              <div>Начало периода</div>
              <div>Окончание периода</div>
              <div>Страховая премия</div>
              <div>Страховая сумма</div>
              <div>Скан договора</div>
              <div></div>
          </div>
        </div>
        {loading ? <LoadingLines /> 
        : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
        : cases.map((caseItem) => (
            <div 
              className='tableRow nonActive' 
              style={{ gridTemplateColumns: '25fr 14fr 12fr 12fr 12fr 12fr 7fr 6fr' }}
              key={caseItem.id} 
            >
              <div>{formatNull(caseItem.insurance_company_name)}</div>
              <div>{formatNull(caseItem.number_agreement)}. {formatDate(caseItem.date_agreement)}</div>
              <div>{formatDate(caseItem.date_start)}</div>
              <div>{formatDate(caseItem.date_end)}</div>
              <div>{formatNull(caseItem.insurance_premium)}</div>
              <div>{formatNull(caseItem.sum_insured)}</div>
              <div>
                {caseItem.file_id ? 
                  <ViewFileById fileId={caseItem.file_id} />
                :
                  <p className='description'>Не было прикреплено</p>
                }
              </div>
              <div style={{alignItems: 'end'}}>
                  <div className='horizontalCell'>
                    <IconContainer Icon={PenIcon} onClick={() => {openSuperModal(caseItem.id, 'change')}} size = '17' color = 'blue' className = '' />
                    <ButtonWithConfirmation 
                        entryFunc={() => {deleteEntry(caseItem.id)}} 
                        Icon={TrashIcon} 
                        IconSize={17}
                        buttonName='Удалить' 
                        color='red' 
                    />
                  </div>
              </div>
            </div>
        ))}
      </div>
    </>
  )
}

export default Insurance;